import React, { Component } from 'react';
import {connect} from 'react-redux';
import { CONFIG } from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import {Link} from 'react-router-dom';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import accountManagement from '../../../../../apis/accountManagement';
import {Row, Col} from 'react-bootstrap';

import ListSiswaCbt from '../../report/tryout/ListSiswaCbt';
import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import DropdownTahunAjaran from '../../masterDropDown/DropdownTahunAjaran';
import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';

class Rekap extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            error: null,
            resMessage: {},
            ta: [],            
            sekolah: null,
            kelas: [],
            KelasParalelSearch :[],
            kodeTa: null,
            idKelas: null,
            idKp: null,
            jadwalExam: [],
            idJadwal: null,
            isFetching: false,
            isSearch: false,
            showAlert: false
        }
    }

    async componentDidMount() {
        document.title = "Rekap";
        this.setState({ isFetching: true });
        await this.props.cekCookies(); 
        if(!__.isEmpty(this.props.account)){
            this.fetchKelas();
            this.fetchTa();
        }


        // window.$("#sidebar").mCustomScrollbar({
        //     theme: "minimal"
        // });
        // window.$('#sidebarCollapse').on('click', function () {
        //     window.$('#sidebar, #content').toggleClass('active');
        //     window.$('.collapse.in').toggleClass('in');
        //     window.$('a[aria-expanded=true]').attr('aria-expanded', 'false');
        // });
        this.setState({ isFetching: false });
    }

    fetchTa = async () =>{
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function(error){
        })
        if(resTa){
            if(resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    ta: resTa.data.data
                })
            }
        }       

        resTa.data.data.map((val) =>{
            if(val.status == "1"){
                this.setState({kodeTa:val.kodeTahunAjaran})
            }
        })

    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});

        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){
        })
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah}).catch(function(error){
        });

        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    fetchJadwalExam = async (idKelas, kodeTa) => {
        this.setState({isFetching: true});
        const response = await accountManagement.post(CONFIG.EXAM_GET_JADWAL_SEKOLAH, {
            ['idKelas']: idKelas, 
            ['idSekolah']: this.props.account.idSekolah,
            ['kodeTa']: kodeTa
        }).catch (function(error){ console.log(error)}) 

        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    jadwalExam: response.data.data
                })
            }
        }

        this.setState({isFetching: false});
    }

    hanldeOnChangeTa = async (e)=>{
        this.setState({kodeTa:e.target.value, jadwalExam : []})
        if(this.state.idKelas !== null) {
            this.fetchJadwalExam(this.state.idKelas, e.target.value);
        }
    }

    handleOnChangeKelas = async (idKelas) => {
        this.setState({            
            idKelas: idKelas.target.value,
            jadwalExam : []
        })
        
        this.setState({isFetching: true});
        this.state.KelasParalelSearch=[];
        this.state.SiswaKelasParalel=[]
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,['idKelas']: idKelas.target.value, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
        })  

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel){
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data
                })
            }
        }

        if(this.state.kodeTa !== null) {
            this.fetchJadwalExam(this.state.idKelas, this.state.kodeTa);
        }
        this.setState({isFetching: false});
    }

    handleOnChangeKelasParalel = async (e) => {
        if(!__.isEmpty(e.target.value)){
            this.setState({            
                idKp: e.target.value
            }) 
            this.renderSiswa()    
        }  
    }

    handleOnChangeJadwal = async (e) => {
        this.setState({ idJadwal: e.target.value })
        this.renderSiswa()  
    }

    handleClick(e) {        
        if(this.state.idJadwal === null || this.state.idKp === null) {
            alert('Parameter Harus Dipilih semua...');
            e.preventDefault();
        } 
    }

    renderSiswa() {       
        
        if(this.state.idJadwal !== null && this.state.idKp !== null) {
            let valJadwal = this.state.idJadwal.split('/');
            console.log(valJadwal)
            return(
                <ListSiswaCbt 
                    tipeCbt='EXAM'
                    account={this.props.account}
                    idKelasParalel={this.state.idKp} 
                    idSekolah={this.props.account.idSekolah}
                    idKelas={this.state.idKelas}
                    idJadwalCbt={valJadwal[0]}
                    tahunAjaran={this.state.kodeTa}
                />   
            ) 
        }
    }

    render() { 
        const {error, isFetching, jadwalExam} = this.state;
        if(error){
            return (<div>Error: {error.message}</div>)
        } 
        return ( 
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Rekapitulasi Exam'}/>  
                   
                    <Row>
                        <Col>
                            <Col><select className="form-control" value={this.state.kodeTa} onChange={this.hanldeOnChangeTa} required>
                                    <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                    <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                </select>
                            </Col> 
                            <Col style={{marginTop:'10px'}}><select className="form-control" value={this.state.idKelas} onChange={this.handleOnChangeKelas} required>
                                    <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                    <DropdownKelas kelas={this.state.kelas} />
                                </select>
                            </Col>
                            <Col style={{marginTop:'10px'}}><select className="form-control" value={this.state.idKp} onChange={this.handleOnChangeKelasParalel} required>
                                    <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                    <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                                </select>
                            </Col>  

                            <Col style={{marginTop:'10px'}}><select className="form-control" value={this.state.idJadwal} onChange={this.handleOnChangeJadwal} required>
                                    <option value="" selected disabled>~~ Pilih Exam ~~</option>
                                    {jadwalExam.map(jadwal => 
                                        <option value={jadwal.idJadwal+'/'+jadwal.idProfil}>{jadwal.namaJadwal}</option>
                                    )}
                                </select>
                            </Col>    

                            <Col style={{marginTop:'10px'}}>
                                <Link to={{ pathname: '/rekapitulasi/rekap_exam/'+ this.state.idJadwal + '/' + this.state.idKp + '/' + this.state.kodeTa }}
                                    onClick={(e) => this.handleClick(e)} target="_blank">
                                    <button className="btn btn-primary">Lihat Rekap</button>
                                </Link>
                                &nbsp;
                                &nbsp;
                                <Link to={{ pathname: '/rekapitulasi/rekap_exam_detail/'+ this.state.idJadwal + '/' + this.state.idKp + '/' + this.state.kodeTa }}
                                    onClick={(e) => this.handleClick(e)} target="_blank">
                                    <button className="btn btn-primary">Lihat Rekap Detail</button>
                                </Link>                           	                            
                            </Col>
                        </Col>    

                        <Col>
                            <h5>Keterangan: </h5>
                            <p>
                                <i className="fa fa-check text-success" aria-hidden="true"></i>  Siswa selesai mengerjakan.
                            </p>
                            <p>
                                <i className="fa fa-remove text-danger" aria-hidden="true"></i>  Siswa belum/tidak selesai mengerjakan.
                            </p>
                        </Col>               
                    </Row>
                    <br/>          

                    {this.renderSiswa()}
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(Rekap); 